import Papa from "papaparse";

/**
 * Neutralises CSV/spreadsheet formula injection (OWASP CSV Injection): a
 * cell value starting with =, +, -, @, tab, or CR is prefixed with a
 * single quote so Excel/Sheets treats it as literal text instead of
 * evaluating it as a formula when the exported file is opened.
 */
export function sanitizeCell(value: unknown): unknown {
  if (typeof value !== "string" || value.length === 0) return value;
  return /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
}

function sanitizeRow<T extends object>(row: T): T {
  const out = {} as T;
  for (const key of Object.keys(row) as (keyof T)[]) {
    out[key] = sanitizeCell(row[key]) as T[keyof T];
  }
  return out;
}

export function downloadCsv<T extends object>(
  filename: string,
  rows: T[],
  columns?: string[],
): void {
  const csv = Papa.unparse(rows.map(sanitizeRow), columns ? { columns } : {});
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}
